import { Box, Grid, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import LogoImage from 'modules/common/component/LogoImage';
import useGeneralHook from 'modules/common/hook/useGeneralHook';
import TextValue from './TextValue';

const Header = () => {
  const { appState } = useGeneralHook();
  const { currentLocation } = appState.authen;
  return (
    <Stack direction="row" sx={{ padding: '9px 48px 0 48px' }}>
      <LogoImage
        src={currentLocation?.avatarId}
        className="logo"
        sx={{
          width: '135px',
          height: 'auto',
          objectFit: 'contain',
          marginRight: '60px',
        }}
      />
      <Box display={'flex'} flexDirection="column">
        <Typography variant="h6" style={{ textTransform: 'uppercase' }}>
          {currentLocation?.name}
        </Typography>
        <Grid container>
          <Grid xs={6}>
            <TextValue label={'medicalPrint.hotline'} value={currentLocation?.phone} labelWidth="60px" />
          </Grid>
          <Grid item xs={6}>
            <TextValue label="clinics.website" value={currentLocation?.website} labelWidth="70px" />
          </Grid>
          <Grid item xs={6}>
            <TextValue label="email" value={currentLocation?.email} labelWidth="60px" />
          </Grid>
          <Grid item xs={6}>
            <TextValue label="clinics.address" value={currentLocation?.address} labelWidth="70px" />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export default Header;
